import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-border-gray mt-16">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Footer links grid - Internal linking for SEO */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-3">Calculadoras</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-xs text-body-text hover:text-blue-primary">Calculadora de Horas</Link></li>
              <li><Link to="/calculadora-de-horas-trabalhadas" className="text-xs text-body-text hover:text-blue-primary">Horas Trabalhadas</Link></li>
              <li><Link to="/calculadora-de-horas-extras" className="text-xs text-body-text hover:text-blue-primary">Horas Extras</Link></li>
              <li><Link to="/calculadora-de-tempo" className="text-xs text-body-text hover:text-blue-primary">Calculadora de Tempo</Link></li>
              <li><Link to="/calculadora-de-minutos" className="text-xs text-body-text hover:text-blue-primary">Calculadora de Minutos</Link></li>
              <li><Link to="/contador-de-horas" className="text-xs text-body-text hover:text-blue-primary">Contador de Horas</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-3">Ferramentas CLT</h3>
            <ul className="space-y-2">
              <li><Link to="/calculadora-de-banco-de-horas" className="text-xs text-body-text hover:text-blue-primary">Banco de Horas</Link></li>
              <li><Link to="/calculadora-de-adicional-noturno" className="text-xs text-body-text hover:text-blue-primary">Adicional Noturno</Link></li>
              <li><Link to="/calculadora-de-subtracao-de-horas" className="text-xs text-body-text hover:text-blue-primary">Subtração de Horas</Link></li>
              <li><Link to="/converter-horas-em-dias" className="text-xs text-body-text hover:text-blue-primary">Converter Horas em Dias</Link></li>
              <li><Link to="/calculo-de-hora-trabalhada" className="text-xs text-body-text hover:text-blue-primary">Valor da Hora Trabalhada</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-3">Guias</h3>
            <ul className="space-y-2">
              <li><Link to="/jornada-de-trabalho" className="text-xs text-body-text hover:text-blue-primary">Jornada de Trabalho</Link></li>
              <li><Link to="/banco-de-horas-como-funciona" className="text-xs text-body-text hover:text-blue-primary">Banco de Horas: Como Funciona</Link></li>
              <li><Link to="/adicional-noturno-horario" className="text-xs text-body-text hover:text-blue-primary">Horário Adicional Noturno</Link></li>
              <li><Link to="/adicional-noturno-valor" className="text-xs text-body-text hover:text-blue-primary">Valor Adicional Noturno</Link></li>
              <li><Link to="/calculo-de-horas-extraordinarias" className="text-xs text-body-text hover:text-blue-primary">Cálculo Horas Extraordinárias</Link></li>
              <li><Link to="/quantas-horas-extras-por-dia" className="text-xs text-body-text hover:text-blue-primary">Limite Horas Extras/Dia</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-3">Institucional</h3>
            <ul className="space-y-2">
              <li><Link to="/sobre" className="text-xs text-body-text hover:text-blue-primary">Sobre</Link></li>
              <li><Link to="/politica-privacidade" className="text-xs text-body-text hover:text-blue-primary">Privacidade</Link></li>
              <li><Link to="/contato" className="text-xs text-body-text hover:text-blue-primary">Contato</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border-gray pt-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex flex-col md:flex-row items-center md:items-center gap-6">
            <a href="https://submitaitools.org" target="_blank" rel="noopener noreferrer">
              <img
                src="https://submitaitools.org/static_submitaitools/images/submitaitools.png"
                alt="Submit AI Tools"
                style={{ borderRadius: '10px', width: '200px', height: '60px' }}
              />
            </a>
            <div className="text-body-text text-sm text-center md:text-left">
              <p>© 2026 Calculadora de Horas. Todos os direitos reservados.</p>
              <p className="mt-1">Cálculos conforme a CLT brasileira.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
